The details of the hiring organization for input types.
